var exports = {
  "J": "FormErrorsItem__qRTgvN",
};

module.exports = exports;
